import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ProductChangeCategoriesDataGrid } from "src/components/views/erp/productChanges/masterData/ProductChangeCategoriesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/productManagement/productChangeCategories")({
	staticData: { title: i18n.t("product_change_categories"), legacyViewKey: "productChangeCategoriesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ProductChangeCategoriesDataGrid />;
}
